import { GeneralTable } from "@/shared/components/ui";
import CustomAutoCompleteGroupBy from "@/shared/components/ui/CustomAutoCompleteGroupBy";
import DateRangeSelector from "@/shared/components/ui/DateRangeSelector";
import { Box, Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { IoTicket } from "react-icons/io5";
import useTicketPendientesAsignacion from "../../hooks/useTicketPendientesAsignacion";
import useTableColumnsTicketPendientesAsignacion from "../../hooks/useTableColumnsTicketPendientesAsignacion";
import { TABLE_CONSTANTS } from "@/shared";
//import VisibilityIcon from '@mui/icons-material/Visibility';
import { dataTicketPendientes } from "../../hooks/dataPendientes";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import ViewAsignacionTecnicos from "../view-asignacion-tecnicos/viewAsignacionTecnicos";
//import { se } from "date-fns/locale";
import dayjs from "dayjs";

type ViewTicketPendientesAsignacionPageProps = {
  title: string;
};

export default function ViewTicketPendientesAsignacionPage({ title }: ViewTicketPendientesAsignacionPageProps) {
  const [estado, setEstado] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false)
  const [selectedRange, setSelectedRange] = useState<any>(null)

  const handleRangeChange = (range: { from: any; to: any }) => {
    const desde = range.from ? dayjs(range.from).format('YYYY-MM-DD') : null;
    const hasta = range.to ? dayjs(range.to).format('YYYY-MM-DD') : null;

    setSelectedRange({ from: desde, to: hasta });
    // TODO: Implement range change logic
  };

  const {
    pagination,
    setPagination
  } = useTicketPendientesAsignacion()

  const {
    columnsTicketPendientes
  } = useTableColumnsTicketPendientesAsignacion()

  return (
    <>
      <Paper elevation={3} sx={{ padding: 2, mb: 2, borderRadius: 2 }}>
        <Typography
          variant="h4"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <IoTicket />
          {title}
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, mt: 2 }}>
          <Box sx={{ flex: 1, maxWidth: 250, mt: 4 }}>
            <Typography fontWeight="bold" sx={{ mb: 1 }}>
              Estado de Tickets
            </Typography>
            <CustomAutoCompleteGroupBy
              label="Seleccione"
              options={[]}
              value={estado}
              onChange={(value) => setEstado(value)}
              getOptionLabel={(op) => op.estado}
              isOptionEqualToValue={(op, val) => op.estado === val.estado}
            />
          </Box>

          <Box sx={{ width: { xs: '100%', md: '40%' }, minWidth: 260 }}>
            <DateRangeSelector
              label="Filtro por fecha"
              onChange={handleRangeChange}
            />
            <Box sx={{ mt: 1 }}>
              {selectedRange ? (
                <Typography variant="body2" color="text.secondary">Fechas seleccionadas: {selectedRange.from ?? '-'} → {selectedRange.to ?? '-'}</Typography>
              ) : (
                <Typography variant="body2" color="text.secondary">No se han seleccionado fechas.</Typography>
              )}
            </Box>

          </Box>


        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <GeneralTable
              columns={columnsTicketPendientes}
              data={dataTicketPendientes || []}
              isLoading={false}
              isRefetching={false}
              ///
              pagination={pagination}
              onPaging={setPagination}
              //
              canEdit={false}
              ///
              actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
              showCustomActionBtnSpace={true}
              customActionBtnSpace={(/* value */) => {
                return (
                  <Grid container >
                    <Grid item>
                      <Tooltip title="Asignar Técnicos">
                        <IconButton
                          onClick={() => setOpenModal(true)}
                        >
                          <AssignmentIndIcon />
                        </IconButton>

                      </Tooltip>
                    </Grid>

                  </Grid>
                )
              }}
            />
          </Grid>
        </Grid>
      </Paper>
      <ScrollableDialogProps
        open={openModal}
        onCloseIcon={() => setOpenModal(false)}
        title="Asignación de tecnicos-#(00000001)"
        minWidth="60%"
        contentNode={
          <ViewAsignacionTecnicos />
        }
        onReject={() => { }}
        showRejectBtn={true}
        rejectTextBtn="Cancelar"
        rejectBtnColor="error"
        showConfirmBtn={true}
        confirmTextBtn="Asignar Técnico"
        onConfirm={() => { setOpenModal(false) }}
        confirmVariantBtn="outlined"
      />
    </>
  );
}